import type { Theme } from '@mui/material/styles';
import type { Components } from '@mui/material/styles/components';

const inverseSurface = '#2e3133';

export const MuiTooltip: Components<Theme>['MuiTooltip'] = {
  defaultProps: {
    arrow: true,
  },
  styleOverrides: {
    tooltip: {
      fontFamily: 'Gellix',
      backgroundColor: inverseSurface,
      marginTop: '0px',
      '.MuiTooltip-popper[data-popper-placement*="bottom"] & ': {
        marginTop: '0px',
      },
      '&.py-custom-tooltip': {
        maxWidth: '420px',
      },
    },
    arrow: {
      color: inverseSurface,
    },
  },
};
